import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, Lock, User } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { adminLogin, auth } from '../lib/api';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(username, password);
      auth.setToken(res.access_token);
      toast.success('Accesso effettuato');
      navigate('/admin', { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      if (typeof detail === 'string') {
        toast.error(detail);
      } else if (err?.response?.status === 401) {
        toast.error('Credenziali non valide');
      } else if (err?.response) {
        toast.error(`Errore server (${err.response.status}). Riprova più tardi.`);
      } else {
        toast.error("Impossibile contattare il server. Verifica la connessione o l'API.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-sky-900 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 rounded-xl bg-sky-100 flex items-center justify-center">
              <Lock className="w-5 h-5 text-sky-600" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-slate-800">Area Amministratore</h1>
              <p className="text-sm text-slate-500">RS Igienizzazione Canali</p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="username">Nome utente</Label>
              <div className="relative mt-1.5">
                <User className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
                <Input
                  id="username"
                  autoComplete="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  className="pl-9"
                  placeholder="admin"
                />
              </div>
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <div className="relative mt-1.5">
                <Lock className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
                <Input
                  id="password"
                  type="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="pl-9"
                  placeholder="••••••••"
                />
              </div>
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-sky-600 hover:bg-sky-700 text-white">
              {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Accesso...</> : 'Accedi'}
            </Button>
          </form>
        </div>
        <p className="text-center text-white/60 text-xs mt-4">
          Accesso riservato. Tutte le attività vengono registrate.
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
